
// Import React for creating the LandingPage component
import React from "react";
// Import CSS for app-wide styling
import "../css/App.css";
// Import images and reusable components
import FamilyImage from "../assets/images/cute-family-playing-summer-field(1).jpg";
import BusinesswomenImage from "../assets/images/close-up-business-partners-shaking-hands.jpg";
import HandshakeImage from "../assets/images/checking-data-laptop.jpg";
import MatureCoupleImage from "../assets/images/businesswomen-doing-interview.jpg";
import ResidentialImage from "../assets/images/happy-family-with-dog-moving-new-home.jpg";
import Hero from "./components/Hero";
import HeroImage from "../assets/images/portrait-happy-family-kitchen-decorated-christmas.jpg";
import Button from "./components/Button";
import CarlyImage from "../assets/images/image0.jpeg";
import { useNavigate } from "react-router-dom";


// LandingPage component displays the main landing page with hero, about, and services sections
const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="landing-page">
      {/* Hero Section with main message and call-to-action button */}
      <Hero
        title={"Tailored financial\nsolutions."}
        subtitle={
          "Expert mortgage and protection advice combined with long term financial planning - delivered with clarity, care, and professionalism."
        }
        backgroundImage={HeroImage}
        titleAlign="left"
        subtitleAlign="left"
        buttonText="BOOK A CONSULTATION"
        onButtonClick={() => {
          navigate("/contact");
        }}
      />

      {/* About Section with company introduction */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-content">
            <div className="about-label">ABOUT US</div>
            <h2 className="about-title">clear, tailored financial advice</h2>
            <p className="about-text">
              Portfolio Finance was created to provide clear, tailored financial
              advice across both residential and commercial needs. We combine
              expert mortgage and protection advice with long-term financial
              planning to support informed, confident decisions - whether for
              your home, your business, or your wider portfolio.
            </p>
            {/* Button to navigate to About page */}
            <Button
              text="FIND OUT MORE"
              variant="primary"
              onClick={() => {
                navigate("/about");
              }}
            />
          </div>
          {/* Founder image */}
          <img src={CarlyImage} alt="Carly" />
        </div>
      </section>

      {/* Services Section with commercial and residential options */}
      <section className="services-section">
        <h2>OUR SERVICES</h2>
        <h3>Commercial Options</h3>

        {/* Commercial Options cards */}
        <div className="service-row">
          <h3 className="service-heading">COMMERCIAL OPTIONS</h3>
          <div className="service-cards">
            {/* Card: Commercial Financial advice */}
            <div className="service-card">
              <img src={HandshakeImage} alt="Commercial Financial advice" />
              <div className="card-content">
                <p className="card-text">
                  Structured financial solutions for commercial portfolios.
                </p>
                <Button
                  text="FIND OUT MORE"
                  variant="card"
                  onClick={() => {
                    navigate("/services#commercial-options");
                  }}
                />
              </div>
            </div>
            {/* Card: Expert advice */}
            <div className="service-card">
              <img src={BusinesswomenImage} alt="Expert advice" />
              <div className="card-content">
                <p className="card-text">
                  Expert advice for commercial property and growth.
                </p>
                <Button
                  text="FIND OUT MORE"
                  variant="card"
                  onClick={() => {
                    navigate("/services#commercial-options");
                  }}
                />
              </div>
            </div>
            {/* Card: Bespoke strategy */}
            <div className="service-card">
              <img src={MatureCoupleImage} alt="Bespoke strategy" />
              <div className="card-content">
                <p className="card-text">
                  Financial clarity for commercial and investment decisions.
                </p>
                <Button
                  text="FIND OUT MORE"
                  variant="card"
                  onClick={() => {
                    navigate("/services#commercial-options");
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <p className="services-description">
          Portfolio Finance supports business owners, investors, and developers
          with tailored commercial financial solutions. From commercial and
          semi-commercial lending to protection and long-term planning, our
          advice is structured, strategic, and aligned with your wider
          objectives.
        </p>

        {/* Residential Section */}
      </section>
      {/* Residential services section */}
      <section className="about-section">
        <div className="about-container reverse">
          <div className="about-content">
            <div className="about-label">Our services</div>
            <h2 className="about-title">Residential</h2>
            <p className="about-text">
              We provide tailored residential financial solutions, offering
              expert mortgage and protection advice alongside long term
              financial planning.
            </p>
            <p className="about-text">
              Whether you’re buying your first home, moving, refinancing, or
              protecting what matters most, our advice is personal, considered,
              and built around your goals.
            </p>
            {/* Button to navigate to Residential services */}
            <Button
              text="FIND OUT MORE"
              variant="primary"
              onClick={() => {
                navigate("/services#residential-mortgages");
              }}
            />
          </div>
          {/* Residential image */}
          <img
            src={ResidentialImage}
            alt="Happy family with dog moving to new home"
          />
        </div>
      </section>
    </div>
  );
};

// Export the LandingPage component as default
export default LandingPage;
